import {useEffect, useState} from 'react'

export default function useBreakpoints(){

    const [currentBreakPoint, setCurrentBreakPoint] = useState("")

    function handleResize(){

        const screenWidth = window.innerWidth

        if(screenWidth <= 576){
            setCurrentBreakPoint("xs")
        }
        else if(screenWidth <= 640 ){
            setCurrentBreakPoint("sm")
        }
        else if(screenWidth <= 924){
            setCurrentBreakPoint("md")
        }
        else if(screenWidth <= 1023){
            setCurrentBreakPoint("lg")
        }
        else if(screenWidth <= 1279){
            setCurrentBreakPoint("lg")
        }
        else if(screenWidth <= 1920){
            setCurrentBreakPoint("2xl")
        }
        else if(screenWidth <= 2560 || screenWidth > 2560){
            setCurrentBreakPoint("3xl")
        }
       
    }

    useEffect(()=>{

        handleResize()
        window.addEventListener("resize", handleResize)

        return ()=>window.removeEventListener("resize", handleResize)
        
    }, [])

    return currentBreakPoint
    
}

